import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router'
import Button from 'material-ui/Button'
import withTheme from 'material-ui/styles/withTheme'
import withStyles from 'material-ui/styles/withStyles'
import {compose} from 'redux'
import {firebaseConnect, isLoaded, isEmpty} from 'react-redux-firebase'
import {push} from 'react-router-redux'
import IconButton from 'material-ui/IconButton'
import SentimentVerySatisfied from 'material-ui-icons/SentimentVerySatisfied'
import {styles} from '../styles'
import Grid from 'material-ui/Grid'
import List, { ListItem, ListItemText } from 'material-ui/List'
import Divider from 'material-ui/Divider'
import HighlightOff from 'material-ui-icons/HighlightOff'
import Avatar from 'material-ui/Avatar'
import {FormControl} from 'material-ui/Form'
import {testStart} from '../action'
import {jobSearchDelete} from '../search/action'
import Card, { CardContent, CardMedia } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import ExtensionIcon from 'material-ui-icons/Extension';
import InsertEmoticonIcon from 'material-ui-icons/InsertEmoticon';
import WorkIcon from 'material-ui-icons/Work';
import {FacebookShareButton, FacebookIcon} from 'react-share'
import {LinearProgress} from 'material-ui/Progress'
function getImageLocation(image) {
  return `https://firebasestorage.googleapis.com/v0/b/mycareer-ai.appspot.com/o/images%2Fjobs%2F${image}.png?alt=media`
}

class MainContainer extends Component {
    state = {
      jobsCount: 0,
    }
    matchLevel = 0
    cognitiveMatch = 0
    softskillsMatch = 0
    wpMatch = 0
    matchText = ['ไม่เหมาะสม','เหมาะสมเพียงเล็กน้อย','ค่อนข้างเหมาะสม','เหมาะสม','เหมาะสมมากที่สุด']

    
    cogMatchText = [
      ['ไม่เหมาะสม โดยท่านมีความสามารถในการเรียนรู้ต่ำกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการอย่างมาก','ไม่เหมาะสม โดยท่านมีความสามารถในการเรียนรู้สูงกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการอย่างมาก'],
      ['มีความเหมาะสมเพียงเล็กน้อย โดยท่านมีความสามารถในการเรียนรู้ต่ำกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการพอสมควร','มีความเหมาะสมเพียงเล็กน้อย โดยท่านมีความสามารถในการเรียนรู้สูงกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการพอสมควร'],
      ['ค่อนข้างเหมาะสม โดยท่านมีความสามารถในการเรียนรู้ต่ำกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการเล็กน้อย','ค่อนข้างเหมาะสม โดยท่านมีความสามารถในการเรียนรู้สูงกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการเล็กน้อย'],
      ['มีความเหมาะสม เมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ'],
      ['มีความเหมาะสมมากที่สุด เมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ']
    ]

    ssMatchText = [
      'ไม่เหมาะสมเมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ โดยทักษะในการปฏิบัติงานที่ท่านมีไม่สอดคล้องกับชุดทักษะของผู้ที่ประสบความสำเร็จในการเรียนและการประกอบอาชีพในสายงานดังกล่าวโดยสิ้นเชิง ',
      'มีความเหมาะสมเพียงเล็กน้อยเมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ โดยทักษะในการปฏิบัติงานที่ท่านมีไม่ค่อยสอดคล้องกับชุดทักษะของผู้ที่ประสบความสำเร็จในการเรียนและการประกอบอาชีพในสายงานดังกล่าวมากนัก ',
      'ค่อนข้างเหมาะสมเมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ โดยทักษะในการปฏิบัติงานที่ท่านมีน่าจะมีส่วนส่งเสริมให้ท่านประสบความสำเร็จในการเรียนและการประกอบอาชีพในสายงานดังกล่าวพอสมควร',
      'มีความเหมาะสมเมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ โดยทักษะในการปฏิบัติงานที่ท่านมีจะมีส่วนส่งเสริมให้ท่านประสบความสำเร็จในการเรียนและการประกอบอาชีพในสายงานดังกล่าวได้',
      'มีความเหมาะสมมากที่สุดเมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ โดยทักษะในการปฏิบัติงานที่ท่านมีจะมีส่วนส่งเสริมให้ท่านประสบความสำเร็จในการเรียนและการประกอบอาชีพในสายงานดังกล่าวอย่างมีนัยสำคัญ'
    ]
    wpMatchText = [
      'ไม่เหมาะสม ท่านอาจรู้สึกไม่มีความสุขกับการเรียนและการทำงานในสายงานนี้อยู่บ่อยครั้ง',
      'มีความเหมาะสมเพียงเล็กน้อย ท่านอาจรู้สึกไม่มีความสุขกับการเรียนและการทำงานในสายงานนี้ในบางครั้ง',
      'ค่อนข้างเหมาะสม ท่านมีแนวโน้มจะมีความสุขกับการเรียนและการทำงานในสายงานดังกล่าวพอสมควร',
      'มีความเหมาะสม ท่านมีแนวโน้มจะมีความสุขกับการเรียนและการทำงานในสายงานดังกล่าว',
      'มีความเหมาะสมมากที่สุด ท่านมีแนวโน้มจะมีความสุขกับการเรียนและการทำงานในสายงานดังกล่าวอย่างมาก '
    ]

    getCogMatchText(score, jobScore, matchingScore) {
      const level = this.getLevel(matchingScore)

      if(level < 3  )
      {
        if(score < jobScore ) {
          //console.log(this.cogMatchText[level])
          return this.cogMatchText[level][0]
        } else {
          //console.log(this.cogMatchText[level])
          return this.cogMatchText[level][1]
        }
      } else {
        return this.cogMatchText[level]
      }
    }


    getLevel(score) {
      if(score <= 50) {
        return 0
      }else if(score <= 62.5) {
        return 1
      }else if(score <= 75) {
        return 2
      } else if(score <= 87.5) {
        return 3
      } else {
        return 4
      }
    }

    

    componentWillReceiveProps(nextProps) {
      //console.log(nextProps)
      if(!isEmpty(nextProps.profile)) {
        if(!isEmpty(nextProps.profile.jobs)) {
        this.setState({jobsCount: Object.keys(nextProps.profile.jobs).length}) 
        }else {
          this.setState({jobsCount: 0}) 
        }
      }
      this.forceUpdate()
      
    }
    componentDidMount() {
      if(!isEmpty(this.props.profile)) {
        if(!isEmpty(this.props.profile.jobs))
        this.setState({jobsCount: Object.keys(this.props.profile.jobs).length}) 
      }

    }
    render() {
      return (
        <div>
          {/*
            this.props.profile !== undefined ?
              this.props.profile.type !== undefined?
                this.props.dispatch(push('/profile')):null
              :null*/
          }
          <Grid container style={{marginTop: "8px"}} className={this.props.classes.centerGrid} spacing={0}>
              
              
              {!isEmpty(this.props.profile)&&
              
              (this.props.profile.currentTest !== 'finished')?
                <div>
                  {!isEmpty(this.props.profile.jobs)&&
                  <List>
                    {Object.keys(this.props.profile.jobs).map((jobId, index) => {
                      return(
                        <div key={index}>
                          <ListItem>
                            {isEmpty(this.props.profile.currentTest)&&
                            <Avatar>
                              <HighlightOff 
                                onClick={()=> this.props.dispatch(jobSearchDelete(jobId,this.props.profile.jobs))}
                              />
                            </Avatar>
                            }

                            <ListItemText 
                              primary={`${this.props.profile.jobs[jobId].name} - ${this.props.profile.jobs[jobId].department}`}
                              secondary={`${this.props.profile.jobs[jobId].faculty} - ${this.props.profile.jobs[jobId].university}`}/>
                          </ListItem>
                          <li>
                            <Divider inset/>
                          </li>
                        </div>
                      )
                    })}
                  </List>
                }
                {/*(isEmpty(this.props.profile.currentTest)||(this.props.profile.type == undefined))&&
                    <FormControl  fullWidth className={this.props.classes.formControl}>
                      <Button  
                          
                          variant="raised"
                          size="large"
                          color="secondary"
                          className={this.props.classes.fullButton}
                          onClick={()=>this.props.dispatch(push('/profile'))}
                        >
                          
                          <span style={{fontSize: '120%'}}>
                              เพิ่มรายละเอียดส่วนตัว
                          </span>
                      </Button>
                    </FormControl>
                  */}
                  {
                      !isEmpty(this.props.profile)&&
                        isEmpty(this.props.profile.type)&&
                        <FormControl  fullWidth className={this.props.classes.formControl}>

                            <Button  
                                //disabled={this.state.jobsCount >= 3 || this.props.profile.type === undefined}
                                variant="raised"
                                size="large"
                                color="secondary"
                                className={this.props.classes.fullButton}
                                onClick={()=>this.props.dispatch(push('/profile'))}
                              >
                                
                                <span style={{fontSize: '120%'}}>
                                    เพิ่มข้อมูลส่วนตัว
                                </span>
                            </Button>
                            </FormControl>
                    }
                  {isEmpty(this.props.profile.currentTest)&&
                    <FormControl  fullWidth className={this.props.classes.formControl}>
                      <Button  
                          disabled={this.state.jobsCount >= 3 || this.props.profile.type === undefined}
                          variant="raised"
                          size="large"
                          color="secondary"
                          className={this.props.classes.fullButton}
                          onClick={()=>this.props.dispatch(push('/search'))}
                        >
                          
                          <span style={{fontSize: '120%'}}>
                              เพิ่มคณะที่สนใจ
                          </span>
                      </Button>
                    </FormControl>
                  }
                    <FormControl  fullWidth className={this.props.classes.formControl}>
                    
                      {(this.props.profile.currentIndex === undefined)?
                        <Button  
                            disabled={this.state.jobsCount < 1}
                            variant="raised"
                            size="large"
                            color="secondary"
                            className={this.props.classes.fullButton}
                            onClick={()=>this.props.dispatch(testStart())}
                          >
                            
                            <span style={{fontSize: '120%'}}>
                                เริ่มทำแบบทดสอบ
                            </span>
                        </Button>
                      :
                      <Button  
                            disabled={this.state.jobsCount < 1}
                            variant="raised"
                            size="large"
                            color="secondary"
                            className={this.props.classes.fullButton}
                            onClick={()=>this.props.dispatch(push('/test'))}
                          >
                            
                            <span style={{fontSize: '120%'}}>
                                ทำแบบทดสอบต่อ
                            </span>
                        </Button>
                    }
                    </FormControl>
                    <br/><br/>
                    {isEmpty(this.props.profile.currentTest)&&

                  <Typography type="caption" style={{margin: '16px'}}>
                      สามารถเลือกสาขาวิชาที่สนใจได้ 3 สาขา<br/>เมื่อเริ่มทำแบบทดสอบแล้ว จะไม่สามารถเลือกสาขาวิชาเพิ่มได้
                    </Typography>
                    }
                </div>
                
                :!isEmpty(this.props.profile)?
                    !isEmpty(this.props.profile.matching)&&
                      <div>
                     
                        {Object.keys(this.props.profile.matching).map((jobId, index) => {
                          return(
                            <div key={index}>
                              <Card style={{display: 'flex', marginBottom: '8px'}}>
                              <div style={{display: 'flex', flexDirection: 'column'}}>
                                  <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <CardMedia
                                      style={{width: '50px', height: '59px', marginLeft: '8px',marginTop: '8px', paddingLeft:'16px', paddingRight: '16px'}}
                                      image={`https://firebasestorage.googleapis.com/v0/b/mycareer-ai.appspot.com/o/images%2F%E0%B8%A3%E0%B8%B0%E0%B8%94%E0%B8%B1%E0%B8%9A%E0%B8%94%E0%B8%B2%E0%B8%A7-0${this.matchLevel = this.getLevel(this.props.profile.matching[jobId].totalMatch)}.png?alt=media`}
                                      title={this.props.profile.jobs[jobId].image}
                                    />
                                    <CardMedia
                                      style={{width: '151px', height: '151px'}}
                                      image={`https://firebasestorage.googleapis.com/v0/b/mycareer-ai.appspot.com/o/images%2Fjobs%2F${this.props.profile.jobs[jobId].image}.png?alt=media`}
                                      title={this.props.profile.jobs[jobId].image}
                                    />
                                    <div style={{display:'flex', flexDirection: 'column'}}>
                                      <CardContent >
                                        <Typography variant="headline">{this.props.profile.jobs[jobId].name}</Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            {this.props.profile.jobs[jobId].department}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            {`${this.props.profile.jobs[jobId].faculty} - ${this.props.profile.jobs[jobId].university}`}
                                        </Typography>
                                        <Typography variant="headline" color="primary">
                                            {this.matchText[this.matchLevel]}
                                        </Typography>
                                        <Typography variant="title" color="primary">
                                            {`${Math.floor(this.props.profile.matching[jobId].totalMatch)}%`}
                                        </Typography>
                                      </CardContent>
                                    </div>
                                  </div>
                                  <Divider/>
                                  <div style={{display: 'flex', flexDirection: 'row'}}>
                                   
                                    <div style={{display:'flex', flexDirection: 'column'}}>
                                      <CardContent >
                                      <div style={{display:'flex', flexDirection: 'row'}}>
                                      <ExtensionIcon style={{marginRight: '8px'}} />
                                        <Typography variant="body1">
                                            {`ความสามารถในการเรียนรู้ของท่านมีความเหมาะสมกับการเรียนคณะ/สาขานี้ ${this.cognitiveMatch=Math.floor(this.props.profile.matching[jobId].cognitiveMatch)}%
                                            ถือว่า ${this.getCogMatchText(
                                              this.cognitiveMatch,
                                              this.props.profile.jobs[jobId].ZCOG,
                                              (this.cognitiveMatch))}`}
                                        </Typography>
                                      </div>
                                      <br/>
                                      <div style={{display:'flex', flexDirection: 'row'}}>
                                        <InsertEmoticonIcon style={{marginRight: '8px'}} />
                                        <Typography variant="body1">
                                            {`ทักษะในการปฏิบัติงานของท่านมีความเหมาะสมกับการเรียนคณะ/สาขานี้ ${this.softskillsMatch=Math.floor(this.props.profile.matching[jobId].softskillsMatch)}%
                                            ถือว่า ${this.ssMatchText[this.getLevel(this.softskillsMatch)]}`}
                                        </Typography>
                                        </div>
                                        <br/>
                                        <div style={{display:'flex', flexDirection: 'row'}}>
                                        <WorkIcon style={{marginRight: '8px'}}/>
                                          <Typography variant="body1" component='p'>
                                            {`ลักษณะความสนใจในงานของท่านมีความเหมาะสมกับการกับการเรียนคณะ/สาขานี้ ${this.wpMatch=Math.floor(this.props.profile.matching[jobId].wpMatch)}%
                                            ถือว่า ${this.wpMatchText[this.getLevel(this.wpMatch)]}`}
                                            
                                        </Typography>
                                        </div><br/>
                                        <div style={{display:'flex', flexDirection: 'row'}}>
                                          <FacebookShareButton 
                                              quote={`คุณสมบัติเหมาะสมกับ ${this.props.profile.jobs[jobId].name} ${Math.floor(this.props.profile.matching[jobId].totalMatch)}%`}
                                              url='https://mycareer.ai/'
                                              children={<div>แชร์ผลลัพธ์ <FacebookIcon size={32}/></div>}


                                          />
                                        </div>
                                      </CardContent>
                                    </div>
                                  </div>
                                </div>
                              </Card>
                            </div>
                          )
                          })
                        }
                        {/*<List>
                          {Object.keys(this.props.profile.matching).map((jobId, index) => {
                            return(
                              <div key={index}>
                                <ListItem>
                                  <Avatar>
                                    <img src={getImageLocation(this.props.profile.jobs[jobId].image)} alt=''/>
                                  </Avatar>
                                  <ListItemText 
                                    primary={this.props.profile.jobs[jobId].department} 
                                    secondary={`${this.props.profile.jobs[jobId].faculty} - ${this.props.profile.jobs[jobId].university}`}/>
                                  <ListItemText 
                                    //primary={parseFloat(Math.round(this.props.profile.matching[jobId].totalMatch*100)/100).toFixed(2)}
                                    primary={parseInt(this.props.profile.matching[jobId].totalMatch)}
                                    secondary={this.props.profile.jobs[jobId].selectedJobs.map((job,index) => {
                                      return(`[${job.jobTH}] `)
                                    })}
                                  />
                                  <ListItemText 
                                    //primary={parseFloat(Math.round(this.props.profile.matching[jobId].totalMatch*100)/100).toFixed(2)}
                                    primary={this.props.profile.jobs[jobId].image}
                                    
                                  />
                                </ListItem>
                                <li>
                                  <Divider inset/>
                                </li>
                              </div>
                            )
                          })}
                        </List>*/}
                      </div>
                    :<LinearProgress style={{width: '350px', marginBottom: '100px', marginTop: '100px'}} color="secondary" variant="indeterminate" />
                }
              
            
            
          </Grid>
            
        </div>
      )
    }
  }
  
  export default compose(
    firebaseConnect(),
    withTheme(),
    withStyles(styles),
  connect(({firebase: {profile}})=>({profile})))(MainContainer)


// WEBPACK FOOTER //
// ./src/main/MainContainer.js